import {BarDetails, BarWithDeals, sortedDeals} from "../../interfaces/Bar";
import {HeaderWithBackground, PageContentCard} from "./HeaderWithBackground";
import {useTranslations} from "next-intl";
import {Card, CardBody, Collapse, Flex, Heading, ListItem, Text, UnorderedList, VStack} from "@chakra-ui/react";
import BarLink from "./BarLink";
import {groupConsecutiveDaysByWorkingHours} from "../../tools/groupHours";
import {DailyOrDayList} from "./DailyOrDayList";
import {TimePeriodView} from "./TimePeriodView";
import {ContributeMenu} from "./widget/ContributeMenu";
import {LastUpdated} from "../LastUpdated";
import {calculateDistance, useGeolocation} from "../tools/useGeolocation";
import DistanceView from "./widget/DistanceView";

export function BarOverview(
    {bar, details}: {bar: BarWithDeals, details?: BarDetails}
) {

    const t = useTranslations("bar")
    const tHome = useTranslations("Home")
    const {location} = useGeolocation()
    return (
        <HeaderWithBackground title={t("title", {bar: bar.name})} bg={"/images/beer.webp"} fullHeight={true}>
            <PageContentCard header={
                <Flex justifyContent="space-between" alignContent="top">
                    <VStack align="start" mt={2}>
                        <Heading size="lg">{bar.name}</Heading>
                        {bar.description && <Heading size="sm">{bar.description}</Heading>}

                        <Card variant="filled">
                            <CardBody>
                                <Text>{bar.address}</Text>
                                <Collapse in={location != null && bar.location != null}>
                                    {location && bar.location && <DistanceView distance={calculateDistance(location, bar.location)} bar={bar}/>}
                                </Collapse>
                                <Collapse in={location == null}>
                                    <BarLink bar={bar}/>
                                </Collapse>
                            </CardBody>
                        </Card>
                    </VStack>
                    <ContributeMenu dealOwner={bar}/>
                </Flex>
            }>

                <Heading size="md">{t("happyhours")}</Heading>
                { bar.updated_at && <LastUpdated updatedAt={bar.updated_at}/> }
                <VStack spacing={5} align="start">
                    <UnorderedList mb={5}>
                        {sortedDeals(bar.deals).map(deal => (
                            <ListItem key={deal.id}>
                                <Text>
                                    {/*<b>{deal.description}</b><br/>*/}
                                    <b>{ tHome("various_offers") }</b><br/>
                                    {groupConsecutiveDaysByWorkingHours(deal.days).map(((a, idx) => (
                                        <>
                                            <DailyOrDayList schedule={a}/>
                                            {" "}
                                            <TimePeriodView period={a.hours}/>
                                            <br/>
                                        </>
                                    )))}
                                </Text>
                            </ListItem>
                        ))}
                    </UnorderedList>
                </VStack>
                <iframe width="100%" height="450" loading="lazy" allowFullScreen
                        src={`https://www.google.com/maps/embed/v1/place?q=place_id:${bar.id}&key=${process.env.NEXT_PUBLIC_MAPS_APIKEY}`}></iframe>
            </PageContentCard>
        </HeaderWithBackground>
    )
}
